<template>
  <div class="install">
    <h4>{{ partner.name }} - {{ steps[index].title }}</h4>
    <hr />

    <template v-for="(step, stepKey) in steps">
      <template v-if="index === stepKey">
        <component
          :createTransaction="createTransaction"
          :transaction="transaction"
          :partner_id="partner_id"
          :updateOrder="updateOrder"
          :index="index"
          :is="step.key"
          :key="stepKey"
          @next="next"
          :order="order"
          @getHash="getHash"
          :hash="hash"
          @getBuyer="getBuyer"
          :buyer="buyer"
          @getContract="getContract"
          :contract="contract"
          :partner="partner"
        />
      </template>
    </template>
  </div>
</template>
<script>
export default {
  props: [
    "order",
    "updateOrder",
    "partner_id",
    "createTransaction",
    "transaction",
    "partner",
  ],
  methods: {
    setFirstCustomer() {
      this.$emit("setFirstCustomer", this.first_customer);
    },
    next(index = 0) {
      if (index < 0) {
        this.$emit("close", true);
      }
      this.index = index;
    },
    getHash(val) {
      this.hash = val;
    },
    getBuyer(val) {
      this.buyer = val;
    },
    getContract(val) {
      this.contract = val;
    },
  },
  name: "filter",
  watch: {
    index(val) {
      if (val < 0 || val >= this.steps.length) {
        this.$modal.hide("install");
        this.index = 0;
      }
    },
  },
  components: {
    "order-add": () => import("./OrderAdd"),
    done: () => import("./Done"),
  },
  created() {
    if (this.transaction) {
      this.index = 1;
      this.contract = this.transaction["exchange_id"];
    }
  },
  data() {
    return {
      first_customer: false,
      //туд сюда данные
      hash: null,
      buyer: null,
      contract: null,
      index: 0, //позиция
      steps: [
        {
          title: "Создание заказа", //4
          key: "order-add",
        },
        {
          title: "Информация о контракте", //6
          key: "done",
        },
      ],
    };
  },
};
</script>

